import { I18n } from 'react-redux-i18n';

/**
 * Converts a nullable boolean value to a localised label.
 * - true  → "Yes"
 * - false → "No"
 * - null / undefined → "N/A"
 *
 * @param value - The nullable boolean value
 * @returns The translated label string
 */
export const getNullableBooleanLabel = (
  value: boolean | null | undefined
): string => {
  if (value === true) return I18n.t('common.yes');
  if (value === false) return I18n.t('common.no');
  return I18n.t('common.not-available');
};

/**
 * The charity newsletter answer on a page, donation or sale. Null means nobody was ever asked
 * (a partner or admin created the record without an answer), which is neither a Yes nor a No.
 * The API always sends the field, so a missing value is missing data and reads N/A.
 */
export const getNewsletterOptInLabel = (
  value: boolean | null | undefined
): string =>
  value === null ? I18n.t('common.notAsked') : getNullableBooleanLabel(value);
